import Notes from "@/components/TableCells/Notes";
import { price } from "@/lib/utils";
import { ListingWithItems } from "@/types";
import { cn } from "@/lib/utils";

export default function MobileListingSubHeaders({
  data,
}: {
  data: ListingWithItems;
}) {
  const mobilePurchaseHeaderData = [
    { label: "Date listed", value: <div>{data.listingDate}</div> },
    { label: "Listed on", value: <div>{data.listingSource}</div> },
    { label: "Sold", value: <div>{data.listingSold ? "true" : "---"}</div> },
    { label: "Sold price", value: <div>{price(data.listingSoldPrice)}</div> },
    {
      label: "Sold shipping",
      value: <div>{price(data.listingSoldShipping)}</div>,
    },
    { label: "Sold fees", value: <div>{price(data.listingSoldFees)}</div> },
    {
      label: "Notes",
      value: data.listingNotes ? <Notes data={data.listingNotes} /> : null,
    },
  ];

  return (
    <div className="col-span-full p-2 columns-2 ">
      {mobilePurchaseHeaderData.map((item) => (
        <div
          key={item.label}
          className={cn(
            "flex gap-x-2 leading-[1.1rem]",
            item.label === "Notes" && "flex-col",
          )}
        >
          <span className="font-bold">
            {item.value !== null && `${item.label}:`}
          </span>
          {item.value}
        </div>
      ))}
    </div>
  );
}
